exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scrollableBody[data-v-3f91ea08]{overflow-y:scroll}.hideScrollBar[data-v-3f91ea08]::-webkit-scrollbar{display:none}.hideScrollBar[data-v-3f91ea08]{-ms-overflow-style:none;scrollbar-width:none}", ""]);

// exports
